import React from 'react';
import styled from 'styled-components';

import Loading from '../../Components/Loading';

const ReportPreview = styled(({ ...rest }) => <div {...rest} />)`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    min-height: 600px;

    .info {
        font-weight: 500;

        .title {
            font-size: 2em;
        }

        .jurisdiction,
        .condition {
            font-size: 1.4em;
            font-weight: 400;
            font-style: italic;
        }
    }

    @media (max-width: 768px) {
        font-size: 0.8rem;

        .info {
            font-weight: 500;

            .title {
                font-size: 1.5em;
            }

            .jurisdiction,
            .condition {
                font-size: 1.2em;
                font-weight: 400;
                font-style: italic;
            }
        }
    }
`;

const Report = styled(({ ...rest }) => <div {...rest} />)`
    display: flex;
    margin: 13px 0;
    flex: 1;
    width: 100%;
    background-color: aliceblue;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;

    .criteria-subsection,
    .logic-section,
    .summary-section {
        margin: 1rem 0;
        padding: 0.5rem;
        border: solid #eee 2px;
        //background-color: #eee;
    }

    .scroll-view {
        width: 100%;
        max-height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;

        &::-webkit-scrollbar {
            background: transparent;
            width: 0.5rem;
        }

        &::-webkit-scrollbar-thumb {
            background: lighten(#337ab7, 50%);
            display: block;
            border-radius: 0.25rem;
        }

        .doc-container {
            padding: 1rem;
            background-color: #fff;
            color: #000;
        }
    }

    .report-section {
        margin: 1rem 0.8rem;

        .reference-section {
            margin-bottom: 2rem;

            .horizontal-scroll-view {
                overflow-x: scroll;

                &::-webkit-scrollbar {
                    background: transparent;
                    width: 0.5rem;
                    height: 0.5rem;
                }

                &::-webkit-scrollbar-thumb {
                    background: lighten(#337ab7, 50%);
                    display: block;
                    border-radius: 0.25rem;
                }

                .reference-table {
                    width: 100%;
                    white-space: nowrap;

                    tr {
                        td,
                        th {
                            white-space: nowrap;
                            padding: 0.5rem;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }

    .concepts {
        padding: 1rem;

        .concept-section {
            margin-left: 2rem;
            margin-bottom: 2rem;
            padding: 5px;

            //border: solid blue 2px;
            .code-section {
                margin-left: 2rem;
                padding: 5px;
                margin-bottom: 2rem;
                //border: solid green 2px;
            }
        }
    }

    .section-header {
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .subsection-header {
        font-size: 1.3rem;
        margin: 0.8rem 0;
    }

    .reference-section-details {
        margin: 1rem 0;
        padding: 0.5rem;
        border: solid #eee 2px;
    }

    .condition-value {
        padding-left: 1rem;
    }

    .data-row,
    .data-header {
        &.grey-bg {
            background-color: #eee;
            padding: 0.2rem;
        }

        margin: 0.3rem;
        display: flex;

        .header {
            font-weight: 600;
        }

        .one {
            width: 100%;
        }

        .one-half {
            width: 50%;
        }

        .one-third {
            width: 33.333%;
        }

        .two-thirds {
            width: 66.666%;
        }

        .one-fourth {
            width: 25%;
        }

        .one-fifth {
            width: 20%;
        }

        .two-fifths {
            width: 40%;
        }

        .three-fifths {
            width: 60%;
        }

        .four-fifths {
            width: 80%;
        }
    }

    .data-row--invalid-data-fallback {
        font-style: italic;
    }

    .data-header {
        font-weight: 600;
        padding: 0.2rem;
    }

    .data-row {
        padding: 0.2rem;
    }

    @media (max-width: 768px) {
        .report-section {
            margin: 0.5em 0.3em;
            font-size: 1em;

            @media (max-width: 550px) {
                font-size: 0.7em;
            }

            .reference-section {
                margin-bottom: 2em;

                .horizontal-scroll-view {
                    overflow-x: scroll;

                    &::-webkit-scrollbar {
                        background: transparent;
                        width: 0.5em;
                        height: 0.5em;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #337ab7;
                        display: block;
                        border-radius: 0.25em;
                    }

                    .reference-table {
                        width: 100%;
                        white-space: nowrap;

                        tr {
                            td,
                            th {
                                white-space: nowrap;
                                padding: 0.5em;
                                text-align: left;
                            }
                        }
                    }
                }
            }
        }

        .section-header {
            font-size: 2em;
            margin: 0.7em 0;
        }

        .subsection-header {
            font-size: 1.3em;
            margin: 0.8em 0;
        }

        .reference-section-details {
            margin: 1em 0;
            padding: 0.5em;
            border: solid #eee 2px;
        }

        .data-row,
        .data-header {
            &.grey-bg {
                background-color: #eee;
                padding: 0.2em;
            }

            margin: 0.3em;
            display: flex;

            .header {
                font-weight: 600;
            }

            .one {
                width: 100%;
            }

            .one-half {
                width: 50%;
            }

            .one-third {
                width: 33.333%;
            }

            .two-thirds {
                width: 66.666%;
            }

            .one-fourth {
                width: 25%;
            }

            .one-fifth {
                width: 20%;
            }

            .two-fifths {
                width: 40%;
            }

            .three-fifths {
                width: 60%;
            }

            .four-fifths {
                width: 80%;
            }
        }

        .concepts {
            padding: 0.5em;

            .concept-section {
                margin-left: 0.5em;
                margin-bottom: 0.5em;
                padding: 5px;

                //border: solid blue 2px;
                .data-row,
                .data-header {
                    flex-wrap: wrap;

                    .one-half {
                        width: 100% !important;
                    }
                }

                .code-section {
                    margin-left: 0.5em;
                    padding: 5px;
                    margin-bottom: 0.5em;
                    //border: solid green 2px;
                }
            }
        }

        .data-header {
            font-weight: 600;
            padding: 0.2em;
        }

        .data-row {
            padding: 0.2em;
        }
    }
`;

class ReportDisplay extends React.Component {
    render() {
        return (
            <ReportPreview>
                <div className="info">
                    <div className="title">{this.props.title}</div>
                    {this.props.condition != null && (
                        <div className="condition">Condition - {this.props.condition}</div>
                    )}
                    <div className="jurisdiction"> Jurisdiction - {this.props.jurisdiction}</div>
                </div>
                <Report>
                    {this.props.loading ? (
                        <Loading textOverride="Preparing Report" />
                    ) : (
                        <div className="scroll-view">
                            <div className="doc-container">
                                {this.props.reportSections.map((i, index) => (
                                    <div className="report-section" key={index}>
                                        {i}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </Report>
            </ReportPreview>
        );
    }
}

export default ReportDisplay;
